import {
	Entitlements,
	GeneralSettings,
	SensorConfigurations,
	SensorGroupsTab,
	SystemConnections,
	ValueMapping,
	ZeroTouchImplementation,
} from '@Components';
import { Stations } from '@Pages/Stations';
import { TFunc } from '../../../i18n/types';
import React from 'react';
import { InnovyzeRole, SecondaryNavItem } from '@innovyze/stylovyze';

import { MAIN_ROUTES } from '@Types/routes';
import MapManagement from '@Pages/MapManagement/MapManagement';

export const generalSettingsPages = (t: TFunc) =>
	[
		{
			title: t('General Settings'),
			content: <GeneralSettings />,
			cy: 'general-settings-btn',
			to: MAIN_ROUTES.GeneralSettings,
			minimumRole: InnovyzeRole.ADMIN,
		},
	] as (SecondaryNavItem & { to: string })[];

export const userManagementPages = (t: TFunc) =>
	[
		{
			title: t('User Management'),
			content: <Entitlements />,
			cy: 'user-management-nav-btn',
			to: MAIN_ROUTES.UserManagement,
			minimumRole: InnovyzeRole.ADMIN,
		},
	] as (SecondaryNavItem & { to: string })[];

export const zeroTouchImplementationPages = (t: TFunc) =>
	[
		{
			title: t('Implementation'),
			content: <ZeroTouchImplementation />,
			cy: 'implementation-btn',
			to: MAIN_ROUTES.Implementation,
			minimumRole: InnovyzeRole.ADMIN,
		},
	] as (SecondaryNavItem & { to: string })[];

export const systemConnectionsPages = (t: TFunc) =>
	[
		{
			title: t('System Connections'),
			content: <SystemConnections />,
			cy: 'system-connections-nav-btn',
			to: MAIN_ROUTES.SystemConnections,
			minimumRole: InnovyzeRole.ADMIN,
		},
	] as (SecondaryNavItem & { to: string })[];

export const sensorConfigurationsPages = (t: TFunc) =>
	[
		{
			title: t('Sensor Configuration'),
			content: <SensorConfigurations />,
			cy: 'sensor-configuration-nav-btn',
			to: MAIN_ROUTES.SensorConfiguration,
			minimumRole: InnovyzeRole.READ_ONLY,
		},
	] as (SecondaryNavItem & { to: string })[];

export const valueMappingTabConfigPages = (t: TFunc) =>
	[
		{
			title: t('Value Mapping'),
			content: <ValueMapping />,
			cy: 'value-mapping-nav-btn',
			to: MAIN_ROUTES.ValueMapping,
			minimumRole: InnovyzeRole.READ_ONLY,
		},
	] as (SecondaryNavItem & { to: string })[];

export const sensorGroupingTabs = (t: TFunc) =>
	[
		{
			title: t('Sensor Groups'),
			content: <SensorGroupsTab />,
			cy: 'sensor-groups-btn',
			to: MAIN_ROUTES.SensorGroups,
			minimumRole: InnovyzeRole.READ_ONLY,
		},
	] as (SecondaryNavItem & { to: string })[];

export const stationTabs = (t: TFunc) =>
	[
		{
			title: t('Facilities'),
			content: <Stations />,
			cy: 'stations-btn',
			to: MAIN_ROUTES.Stations,
			minimumRole: InnovyzeRole.READ_ONLY,
		},
	] as (SecondaryNavItem & { to: string })[];

export const mapManagementTabs = () =>
	[
		{
			title: 'Map Management',
			content: <MapManagement />,
			cy: 'map-management-btn',
			to: '/admin/map-management',
			minimumRole: InnovyzeRole.ADMIN,
		},
	] as (SecondaryNavItem & { to: string })[];
